import React from "react";
import {useSelector} from "react-redux";
import {css, Theme, useTheme} from "@emotion/react";
import styled from "@emotion/styled";

import {calculateRemSize as crs, flex, flexDirection, m, mb, mr, pointer, w100} from "@pg-design/helpers-css";
import {MapMarkerOutlineIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {IRPStore} from "../app/rp_reducer";
import {ViewType} from "../view_type/ViewType";
import {SeoMainHeadline} from "./SeoMainHeadline";

interface IProps {
    address: string;
    badges?: React.ReactNode;
    cta?: React.ReactNode;
    externalLinks?: React.ReactNode;
    onLocationClick: () => void;
    title: React.ReactNode;
    subTitle?: React.ReactNode;
    slogan?: string;
    addressRowButton?: React.ReactNode;
    isSpain?: boolean;
    offerType?: number;
    addressWithPointer?: boolean;
    additionalInformation?: React.ReactNode;
}

export const DetailViewHeader = (props: IProps) => {
    const {addressWithPointer = true} = props;
    const theme = useTheme();
    const viewType = useSelector((state: IRPStore) => state.viewType.current);

    return (
        <div css={detailViewHeader}>
            <div css={detailsWrapper}>
                <div css={heading}>
                    {viewType === ViewType.OFFER ? (
                        <SeoMainHeadline as="h1" variant="headline_2" css={mainHeadLine}>
                            {props.title}
                        </SeoMainHeadline>
                    ) : (
                        <Text as="h1" variant="headline_2" css={mainHeadLine}>
                            {props.title}
                        </Text>
                    )}

                    <div css={cta}>{props.cta}</div>

                    {props.subTitle && (
                        <Text color={theme.colors.gray[700]} css={subtitle} variant="info_txt_1">
                            {props.subTitle}
                        </Text>
                    )}

                    {props.badges && <div css={badgesWrapper}>{props.badges}</div>}

                    {props.slogan && <Text css={slogan}>{props.slogan}</Text>}
                </div>
                {props.additionalInformation && <div css={mb(2)}>{props.additionalInformation}</div>}

                {props.externalLinks && <div css={mb(2)}>{props.externalLinks}</div>}

                <AddressWrapper withPointer={addressWithPointer} onClick={props.onLocationClick}>
                    <div css={[flex("center")]}>
                        <MapMarkerOutlineIcon css={mr()} size="1.6" />
                        <Text variant="body_copy_1">{props.address}</Text>
                    </div>
                    {props.addressRowButton}
                </AddressWrapper>
            </div>
        </div>
    );
};

const detailViewHeader = (theme: Theme) => css`
    display: flex;
    position: relative;
    flex-wrap: wrap;
    ${w100};

    @media (min-width: ${theme.breakpoints.md}) {
        flex-wrap: nowrap;
    }
`;

const detailsWrapper = (theme: Theme) => css`
    flex: 1;
    padding: ${`${crs(2)} 0 ${crs(1.25)} 0`};

    @media (min-width: ${theme.breakpoints.md}) {
        flex-grow: 1;
        flex-shrink: 1;
        margin-bottom: 0;
    }
`;

const heading = css`
    display: flex;
    flex-wrap: wrap;
    padding-top: ${crs(0.5)};
    row-gap: ${crs(2)};
`;

const ctaMaxWidth = "1000px";
const mainHeadLine = css`
    flex: 1 1 calc(100% - ${ctaMaxWidth});
`;

const cta = css`
    display: flex;
    flex: 0 0 auto;
    align-items: flex-start;
    padding: 0 0 0 ${crs(1)};
`;

const subtitle = css`
    flex: 1 0 100%;
`;

const badgesWrapper = css`
    flex: 1 0 100%;
    ${mb(2)};
    ${flex()};
    column-gap: 1.6rem;
`;

const AddressWrapper = styled.h2<{withPointer?: boolean}>`
    ${({theme, withPointer}) => css`
        ${flex("flex-start")};
        ${withPointer ? pointer : ""};
        font-style: normal;
        gap: ${crs(2)};
        ${flexDirection("column")};
        ${m(0)};

        @media (min-width: ${theme.breakpoints.md}) {
            ${flex("center")};
            ${flexDirection("row")}
        }
    `}
`;

const slogan = css`
    flex: 1 0 100%;
    ${mb(2)};
`;
import React from "react";
import {useSelector} from "react-redux";
import {css, Theme, useTheme} from "@emotion/react";
import styled from "@emotion/styled";

import {calculateRemSize as crs, flex, flexDirection, m, mb, mr, pointer, w100} from "@pg-design/helpers-css";
import {MapMarkerOutlineIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {IRPStore} from "../app/rp_reducer";
import {ViewType} from "../view_type/ViewType";
import {SeoMainHeadline} from "./SeoMainHeadline";

interface IProps {
    address: string;
    badges?: React.ReactNode;
    cta?: React.ReactNode;
    externalLinks?: React.ReactNode;
    onLocationClick: () => void;
    title: React.ReactNode;
    subTitle?: React.ReactNode;
    slogan?: string;
    addressRowButton?: React.ReactNode;
    isSpain?: boolean;
    offerType?: number;
    addressWithPointer?: boolean;
    additionalInformation?: React.ReactNode;
}

export const DetailViewHeader = (props: IProps) => {
    const {addressWithPointer = true} = props;
    const theme = useTheme();
    const viewType = useSelector((state: IRPStore) => state.viewType.current);

    return (
        <div css={detailViewHeader}>
            <div css={detailsWrapper}>
                <div css={heading}>
                    {viewType === ViewType.OFFER ? (
                        <SeoMainHeadline as="h1" variant="headline_2" css={mainHeadLine}>
                            {props.title}
                        </SeoMainHeadline>
                    ) : (
                        <Text as="h1" variant="headline_2" css={mainHeadLine}>
                            {props.title}
                        </Text>
                    )}

                    <div css={cta}>{props.cta}</div>

                    {props.subTitle && (
                        <Text color={theme.colors.gray[700]} css={subtitle} variant="info_txt_1">
                            {props.subTitle}
                        </Text>
                    )}

                    {props.badges && <div css={badgesWrapper}>{props.badges}</div>}

                    {props.slogan && <Text css={slogan}>{props.slogan}</Text>}
                </div>
                {props.additionalInformation && <div css={mb(2)}>{props.additionalInformation}</div>}

                {props.externalLinks && <div css={mb(2)}>{props.externalLinks}</div>}

                <AddressWrapper withPointer={addressWithPointer} onClick={props.onLocationClick}>
                    <div css={[flex("center")]}>
                        <MapMarkerOutlineIcon css={mr()} size="1.6" />
                        <Text variant="body_copy_1">{props.address}</Text>
                    </div>
                    {props.addressRowButton}
                </AddressWrapper>
            </div>
        </div>
    );
};

const detailViewHeader = (theme: Theme) => css`
    display: flex;
    position: relative;
    flex-wrap: wrap;
    ${w100};

    @media (min-width: ${theme.breakpoints.md}) {
        flex-wrap: nowrap;
    }
`;

const detailsWrapper = (theme: Theme) => css`
    flex: 1;
    padding: ${`${crs(2)} 0 ${crs(1.25)} 0`};

    @media (min-width: ${theme.breakpoints.md}) {
        flex-grow: 1;
        flex-shrink: 1;
        margin-bottom: 0;
    }
`;

const heading = css`
    display: flex;
    flex-wrap: wrap;
    padding-top: ${crs(0.5)};
    row-gap: ${crs(2)};
`;

const ctaMaxWidth = "1000px";
const mainHeadLine = css`
    flex: 1 1 calc(100% - ${ctaMaxWidth});
`;

const cta = css`
    display: flex;
    flex: 0 0 auto;
    align-items: flex-start;
    padding: 0 0 0 ${crs(1)};
`;

const subtitle = css`
    flex: 1 0 100%;
`;

const badgesWrapper = css`
    flex: 1 0 100%;
    ${mb(2)};
    ${flex()};
    column-gap: 1.6rem;
`;

const AddressWrapper = styled.h2<{withPointer?: boolean}>`
    ${({theme, withPointer}) => css`
        ${flex("flex-start")};
        ${withPointer ? pointer : ""};
        font-style: normal;
        gap: ${crs(2)};
        ${flexDirection("column")};
        ${m(0)};

        @media (min-width: ${theme.breakpoints.md}) {
            ${flex("center")};
            ${flexDirection("row")}
        }
    `}
`;

const slogan = css`
    flex: 1 0 100%;
    ${mb(2)};
`;
